export const COMPONENT_NAME = 'ZDescriptionsItem'
